module.exports = __webpack_public_path__ + "static/buffer.0f6e09c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/buffer.jpg
// module id = 841
// module chunks = 73261030922168